import { ThemeParameters, RuntimeThemeParameters } from '../../types';
import { graphDefault, graphGridLines, graphOutlinesUnfilled, graphDataStyle } from './';
import { relativeLuminance } from '../util';
import { scaleLightness, neutralLightenShiftFactor, neutralDarkenShiftFactor } from '../../colors';

export const graphNodeLink = (theme: ThemeParameters, parameters: RuntimeThemeParameters) => {
  const styleDefault = graphDataStyle.styleDefault(theme, parameters);
  const graphDefaultPattern = graphDefault(theme, parameters);
  const common = {
    lineStyle: styleDefault.lineStyle,
  };
  switch (theme.baseThemeName) {
    case 'dark': {
      const color = relativeLuminance(graphDefaultPattern.n_1);
      const altColor = relativeLuminance(
        scaleLightness(-0.1 * neutralDarkenShiftFactor, graphDefaultPattern.n)
      );
      return {
        ...common,
        color,
        fillColor: color,
        altColor,
        lineColor: altColor,
        markerColor: altColor,
        lineThickness: 2,
      };
    }
    case 'high-contrast': {
      const color = graphGridLines(theme, parameters).lineColor;
      const altColor = graphOutlinesUnfilled(theme, parameters).lineColor;
      return {
        ...common,
        color,
        fillColor: color,
        altColor,
        lineColor: altColor,
        markerColor: altColor,
        lineThickness: styleDefault.lineThickness,
      };
    }
    default: {
      const color = relativeLuminance(graphDefaultPattern.n1);
      const altColor = relativeLuminance(
        scaleLightness(0.1 * neutralLightenShiftFactor, graphDefaultPattern.n)
      );
      return {
        ...common,
        color,
        fillColor: color,
        altColor,
        lineColor: altColor,
        markerColor: altColor,
        lineThickness: 2,
      };
    }
  }
};
